import { TICK_DURATION } from "@/config/constants";
import { ResourceType } from "@/game/entities/config/resources";
import type { ConversionOffer } from "@/types/shop";
import { OfferType } from "@/types/ui";

const TICKS_PER_MIN = 60 / TICK_DURATION;

const COINS_FOR_EVENTIUM: Map<number, ConversionOffer> = new Map([
	[
		1,
		{
			id: 1,
			type: OfferType.COINS_FOR_EVENTIUM,
			value: {
				[ResourceType.COINS]: (income: number): number => {
					// 15 min income

					return Math.trunc(income * (15 * TICKS_PER_MIN));
				},
			} as ConversionOffer["value"],
			price: { [ResourceType.EVENTIUM]: 10_000_000 },
		},
	],
	[
		2,
		{
			id: 2,
			type: OfferType.COINS_FOR_EVENTIUM,
			value: {
				[ResourceType.COINS]: (income: number): number =>
					// 60 min income
					Math.trunc(income * (60 * TICKS_PER_MIN)),
			} as ConversionOffer["value"],
			price: { [ResourceType.EVENTIUM]: 30_000_000 },
		},
	],
]);

const RESOURCES_FOR_EVENTIUM_OFFERS: Map<number, ConversionOffer> = new Map([
	[
		1,
		{
			id: 1,
			type: OfferType.RESOURCES_FOR_EVENTIUM,
			value: {
				[ResourceType.LUMBER]: (
					_storage: number,
					income: number,
				): number =>
					// 20 min income
					Math.trunc(income * (20 * TICKS_PER_MIN)),
			} as ConversionOffer["value"],
			price: { [ResourceType.EVENTIUM]: 5_000_000 },
		},
	],
	[
		2,
		{
			id: 2,
			type: OfferType.RESOURCES_FOR_EVENTIUM,
			value: {
				[ResourceType.STONE]: (
					_storage: number,
					income: number,
				): number =>
					// 20 min income
					Math.trunc(income * (20 * TICKS_PER_MIN)),
			} as ConversionOffer["value"],
			price: { [ResourceType.EVENTIUM]: 5_000_000 },
		},
	],
	[
		3,
		{
			id: 3,
			type: OfferType.RESOURCES_FOR_EVENTIUM,
			value: {
				[ResourceType.CLAY]: (
					_storage: number,
					income: number,
				): number =>
					// 20 min income
					Math.trunc(income * (20 * TICKS_PER_MIN)),
			} as ConversionOffer["value"],
			price: { [ResourceType.EVENTIUM]: 5_000_000 },
		},
	],
	[
		4,
		{
			id: 4,
			type: OfferType.RESOURCES_FOR_EVENTIUM,
			value: {
				[ResourceType.IRON]: (
					_storage: number,
					income: number,
				): number =>
					// 20 min income
					Math.trunc(income * (20 * TICKS_PER_MIN)),
			} as ConversionOffer["value"],
			price: { [ResourceType.EVENTIUM]: 5_000_000 },
		},
	],
	[
		5,
		{
			id: 5,
			type: OfferType.RESOURCES_FOR_EVENTIUM,
			value: {
				[ResourceType.GOODS]: (
					_storage: number,
					income: number,
				): number =>
					// 20 min income
					Math.trunc(income * (20 * TICKS_PER_MIN)),
			} as ConversionOffer["value"],
			price: { [ResourceType.EVENTIUM]: 5_000_000 },
		},
	],
	[
		6,
		{
			id: 6,
			type: OfferType.RESOURCES_FOR_EVENTIUM,
			value: {
				[ResourceType.STEEL]: (
					_storage: number,
					income: number,
				): number =>
					// 20 min income
					Math.trunc(income * (20 * TICKS_PER_MIN)),
			} as ConversionOffer["value"],
			price: { [ResourceType.EVENTIUM]: 5_000_000 },
		},
	],
]);

const SUPER_CLICKER_FREE: Map<number, ConversionOffer> = new Map([
	[
		1,
		{
			id: 1,
			type: OfferType.SUPER_CLICKER_FREE,
			value: { [ResourceType.SUPER_CLICKER]: 10 },
			price: null,
			description: "event.available_once_a_day",
			limit: {
				current: 0,
				max: 1,
			},
		},
	],
]);

export const EVENT_CONVERSION_OFFERS_CONFIG = {
	COINS_FOR_EVENTIUM,
	RESOURCES_FOR_EVENTIUM_OFFERS,
	SUPER_CLICKER_FREE,
} as const;
